import * as React from "react";
import type { SVGProps } from "react";
const SvgPlusMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 10H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1M19 23H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1"
    />
    <path
      fill="currentColor"
      d="M12 17c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1s1 .45 1 1v14c0 .55-.45 1-1 1"
    />
  </svg>
);
export default SvgPlusMinus;
